import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation ,Link } from 'react-router-dom';
import axios from 'axios';
import { Table, Typography, Spin, Alert, Button, Modal, Input, Select ,DatePicker} from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UndoOutlined } from '@ant-design/icons';



import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const { Title, Paragraph } = Typography;
const { Search, TextArea } = Input;


function FirstInstallments() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');

    const [showFilters, setShowFilters] = useState(false);

    const base =
     (role === 'ADMIN') ? "/admin-home"
      : "/user-home";

      const fullPath = `${base}/dashboard-first-installment`

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  

  // Helper for safe display
  const safe = (val) => (val !== null && val !== undefined ? val : '-');

  // 🔐 Verify authentication
  useEffect(() => {
    const verifyUser = async () => {
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          { email, role, token }
        );
        if (!res.data.success) {
          const errMsg = res?.data?.message || 'Please Login Again.';
      toast.error(errMsg);
          localStorage.clear();
          navigate('/login');
        }
      } catch (err) {
        // console.error('User verification failed:', err?.message || err);
        const msg = err?.response?.data?.message || err?.message || 'Please Login Again.';
    toast.error(msg);
        localStorage.clear();
        navigate('/login');
      }
    };
    verifyUser();
  }, [navigate, location.pathname, token, email, role]);

  // 🧾 Fetch all first installment leads
    const fetchLeads = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/firstinstallment/all-first-installment-leads`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res.data?.success) {
          const data = Array.isArray(res.data.data) ? res.data.data : [];
          setLeads(
            data.map((item, index) => ({
              ...item,
              key: item.Email || index,
            }))
          );
        } else {
          toast.error('Failed to load leads');
        }
      } catch (err) {
        console.error('Error fetching first installment leads:', err);
        setError(err?.response?.data?.message || 'Error fetching leads');
        toast.error('Failed to fetch leads');
      } finally {
        setLoading(false);
      }
    };


   useEffect(() => {
      fetchLeads();
    }, [token, location.key,navigate]);

  // Payment modal + sending state
const [paymentModalVisible, setPaymentModalVisible] = useState(false);
const [paymentModalLoading, setPaymentModalLoading] = useState(false);
const [selectedPaymentRecord, setSelectedPaymentRecord] = useState(null);


// track sending per-record so buttons show spinner
const [paymentSendingKeys, setPaymentSendingKeys] = useState(new Set());

const openPaymentModal = (record) => {
  setSelectedPaymentRecord(record);
  setPaymentModalVisible(true);
};

const handleSendPaymentLink = async (record) => {
  if (!record?.Email) {
    toast.error('Record missing Email');
    return;
  }

  const keyName = `payment-${record.key}`;

  // mark sending
  setPaymentSendingKeys(prev => {
    const next = new Set(prev);
    next.add(keyName);
    return next;
  });

  setPaymentModalLoading(true);

  try {
    const payload = {
      Email: record.Email,
      PhoneNumber: record.PhoneNumber,
    };

    // prefer POST as you specified; adjust to PUT if needed
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/send-payment-link`;
    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Payment link sent');

      // // update UI row: mark PaymentLink_1 SENT and optionally set actual link if returned
      setLeads(prev =>
        prev.map(r =>
          r.key === record.key
            ? {
                ...r,
                PaymentLink_1: 'SENT',
               
              }
            : r
        )
      );

      // keep modal open if you want — or close
      setPaymentModalVisible(false);
    } else {
      const errMsg = res?.data?.message || 'Failed to send payment link';
      toast.error(errMsg);
    }
  } catch (err) {
    console.error('send-payment-link error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setPaymentSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
    setPaymentModalLoading(false);
  }
};


// Call status modal + loading state
const [callStatusModalVisible, setCallStatusModalVisible] = useState(false);
const [callStatusRecord, setCallStatusRecord] = useState(null);
const [callStatusValue, setCallStatusValue] = useState(null);
const [callStatusLoading, setCallStatusLoading] = useState(false);

// track per-record sending state
const [callStatusSendingKeys, setCallStatusSendingKeys] = useState(new Set());

// open modal helper
const openCallStatusModal = (record) => {
  setCallStatusRecord(record);
  // preselect current value if present, normalize
  const cur = (record?.CallStatus ?? '').toString().toUpperCase();
  setCallStatusValue(cur || null);
  setCallStatusModalVisible(true);
};

const handleUpdateCallStatus = async () => {
  if (!callStatusRecord || !callStatusRecord.Email) {
    toast.error('No record selected');
    return;
  }
  if (!callStatusValue) {
    toast.error('Select call status');
    return;
  }

  const keyName = `callstatus-${callStatusRecord.key}`;
  // mark sending
  setCallStatusSendingKeys(prev => {
    const next = new Set(prev);
    next.add(keyName);
    return next;
  });
  setCallStatusLoading(true);

  try {
    const payload = {
      Email: callStatusRecord.Email,
      CallStatus: callStatusValue,
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/update-call-status`;
    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Call status updated');

      // update local leads array (keep shape unchanged)
      setLeads(prev => prev.map(r => r.key === callStatusRecord.key ? { ...r, CallStatus: callStatusValue } : r));

      setCallStatusModalVisible(false);
    } else {
      const err = res?.data?.message || 'Failed to update call status';
      toast.error(err);
    }
  } catch (err) {
    console.error('update-call-status error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setCallStatusLoading(false);
    setCallStatusSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};

const [commentModalVisible, setCommentModalVisible] = useState(false);
const [commentRecord, setCommentRecord] = useState(null);
const [commentValue, setCommentValue] = useState("");
const [commentLoading, setCommentLoading] = useState(false);
const [commentSendingKeys, setCommentSendingKeys] = useState(new Set());


const handleUpdateComment = async () => {
  if (!commentRecord || !commentRecord.Email) {
    toast.error("No record selected");
    return;
  }

  if (!commentValue.trim()) {
    toast.error("Please enter comment");
    return;
  }

  const keyName = `comment-${commentRecord.key}`;

  setCommentSendingKeys((prev) => {
    const next = new Set(prev);
    next.add(keyName);
    return next;
  });

  setCommentLoading(true);

  try {
    const payload = {
      Email: commentRecord.Email,
      Comment: commentValue.trim(),
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(
      /\/$/,
      ""
    )}/firstinstallment/update-comment`;

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Comment updated");

      setLeads((prev) =>
        prev.map((r) =>
          r.key === commentRecord.key
            ? { ...r, Comment: commentValue.trim() }
            : r
        )
      );

      setCommentModalVisible(false);
      setCommentRecord(null);
      setCommentValue("");
    } else {
      toast.error(res?.data?.message || "Failed to update comment");
    }
  } catch (err) {
    console.error("update-comment error", err);

    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Network/server error"
    );
  } finally {
    setCommentLoading(false);

    setCommentSendingKeys((prev) => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};

// Inside component function (first installment) - add these new state variables:
const [actionModalVisible, setActionModalVisible] = useState(false);
const [actionRecord, setActionRecord] = useState(null);
const [movingKeys, setMovingKeys] = useState(new Set());

// Upcoming Batch modal state
const [upcomingModalVisible, setUpcomingModalVisible] = useState(false);
const [upcomingModalLoading, setUpcomingModalLoading] = useState(false);
const [upcomingDemoLinks, setUpcomingDemoLinks] = useState([]);
const [selectedUpcomingDemoKey, setSelectedUpcomingDemoKey] = useState(null);
const [selectedUpcomingDemoRow, setSelectedUpcomingDemoRow] = useState(null);
const [upcomingComments, setUpcomingComments] = useState('');
const [upcomingMovingKey, setUpcomingMovingKey] = useState(null);

// Drop modal state (if not already present)
const [dropModalVisible, setDropModalVisible] = useState(false);
const [dropComments, setDropComments] = useState('');
const [dropLoading, setDropLoading] = useState(false);


 // helper to set/unset movingKeys
const setMoving = (key, on = true) => {
  setMovingKeys(prev => {
    const next = new Set(prev);
    if (on) next.add(key);
    else next.delete(key);
    return next;
  });
};

// open Action modal
const openActionModal = (record) => {
  setActionRecord(record);
  setActionModalVisible(true);
};

// --- Move to Pending Installments ---
const handleMoveToPendingInstallment = async (record) => {
  if (!record || !record.Email) return toast.error('Invalid record');
  const key = `move-enrollment-${record.key}`;
  setMoving(key, true);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/move-to-pending-installment-stage`;
    const payload = {
      Email: record.Email
    };

    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to pending-installment');
      // remove from local list
      setLeads(prev => prev.filter(r => r.key !== record.key));
      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || 'Failed to move to pending-installment');
    }
  } catch (err) {
    console.error('move-to-enrollments error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setMoving(key, false);
  }
};

const handleMoveToEnrollments = async (record) => {
  if (!record || !record.Email) {
    return toast.error("Invalid record");
  }

  const key = `move-enrollment-${record.key}`;
  setMoving(key, true);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(
      /\/$/,
      ""
    )}/firstinstallment/move-to-enrollments-stage`;

    const payload = {
      Email: record.Email,
    };

    const res = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Moved to enrollments");

      setLeads((prev) => prev.filter((r) => r.key !== record.key));

      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || "Failed to move to enrollments");
    }
  } catch (err) {
    console.error("move-to-enrollments error", err);

    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Network/server error"
    );
  } finally {
    setMoving(key, false);
  }
};

// --- Open Upcoming Batch modal and load available batches (demolinks) ---
const openUpcomingModal = async (record) => {
  if (!record) return;
  setActionRecord(record);
  setUpcomingModalVisible(true);
  setSelectedUpcomingDemoKey(null);
  setSelectedUpcomingDemoRow(null);
  setUpcomingComments('');
  setUpcomingDemoLinks([]);
  setUpcomingModalLoading(true);

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/demolinks/all-demolinks`, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 15000,
    });
    const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.links || [];
    setUpcomingDemoLinks(Array.isArray(data) ? data.map((r,i)=>({ key: r.id ?? `dl-${i}`, ...r })) : []);
  } catch (err) {
    console.error('Failed to fetch demolinks for upcoming batches', err);
    toast.error('Failed to load batches');
  } finally {
    setUpcomingModalLoading(false);
  }
};

const handleSelectUpcomingRow = (rec) => {
  setSelectedUpcomingDemoKey(rec.key);
  setSelectedUpcomingDemoRow(rec);
};

// --- Confirm Move To Upcoming Batch ---
const handleConfirmMoveToUpcomingBatch = async () => {
  if (!actionRecord || !selectedUpcomingDemoRow) {
    toast.error('Select a batch first');
    return;
  }

 const record = actionRecord;
   const selectedRow = upcomingDemoLinks.find((r) => r.key === selectedUpcomingDemoKey);
   // console.log(selectedRow);
   
   if (!selectedRow) {
     toast.error('Select a batch option first');
     return;
   }
 
   const AvailabilityBatch = `${selectedRow.Day}-${selectedRow.Month}-${selectedRow.Year}`
   if (!AvailabilityBatch || AvailabilityBatch === '-') {
     toast.error('Selected batch has invalid date');
     return;
   }
 
   const BatchDay = selectedRow.BatchDay ;
   const Comments = upcomingComments ;
 
   const payload = {
     Email: record.Email,
     AvailabilityBatch,
     BatchDay,
     Comments,
   };
 
   const key = `move-upcoming-${record.key}`;
   setMoving(key, true);
   setUpcomingMovingKey(key);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/move-to-upcoming-batch`;
    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 20000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to upcoming batch');
      // remove lead from UI list
      setLeads(prev => prev.filter(r => r.key !== actionRecord.key));
      setUpcomingModalVisible(false);
      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || 'Failed to move to upcoming batch');
    }
  } catch (err) {
    console.error('move-to-upcoming-batch error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setMoving(key, false);
    setUpcomingMovingKey(null);
  }
};

// --- Drop The Lead (use drop modal with comments) ---
// const openDropModal = (record) => {
//   setActionRecord(record);
//   setDropComments('');
//   setDropModalVisible(true);
// };


  const handleDropLeadConfirm = async (record) => {
    if (!record?.Email) {
      toast.error('No email present for selected lead');
      return;
    }

    const key = `drop-lead-${record.key}`;
    setMovingKeys(prev => {
      const next = new Set(prev); next.add(key); return next;
    });
    setDropLoading(true);

    try {
      const payload = { Email: record.Email, Comments: dropComments ?? '' };
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/drop-lead`;
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (res?.data?.success || [200,201].includes(res?.status)) {
        toast.success(res?.data?.message || 'Lead dropped successfully');
        setLeads(prev => prev.filter(r => r.key !== record.key));
        setDropModalVisible(false);
        setActionModalVisible(false);
      } else {
        const msg = res?.data?.message || 'Failed to drop lead';
        toast.error(msg);
      }
    } catch (err) {
      console.error('Drop lead error', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
    } finally {
      setDropLoading(false);
      setMovingKeys(prev => {
        const next = new Set(prev); next.delete(key); return next;
      });
    }
  };

// Enrolled-status modal state
const [enrolledModalVisible, setEnrolledModalVisible] = useState(false);
const [enrolledRecord, setEnrolledRecord] = useState(null);
const [enrolledValue, setEnrolledValue] = useState(null);
const [enrolledLoading, setEnrolledLoading] = useState(false);

// per-record sending keys (optional, keeps UI consistent with your other patterns)
const [enrolledSendingKeys, setEnrolledSendingKeys] = useState(new Set());

// helper to open modal
const openEnrolledModal = (record) => {
  setEnrolledRecord(record);
  const cur = (record?.Enrolled ?? '').toString().toUpperCase();
  setEnrolledValue(cur || null);
  setEnrolledModalVisible(true);
};

const handleChangeEnrolledStatus = async () => {
  if (!enrolledRecord || !enrolledRecord.Email) {
    toast.error('No record selected');
    return;
  }
  if (!enrolledValue) {
    toast.error('Select enrolled status');
    return;
  }

  const keyName = `enrolled-${enrolledRecord.key}`;

  // mark sending/loading
  setEnrolledSendingKeys(prev => {
    const next = new Set(prev);
    next.add(keyName);
    return next;
  });
  setEnrolledLoading(true);

  try {
    const payload = {
      Email: enrolledRecord.Email,
      Enrolled: enrolledValue, // expected YES / NO / PENDING
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/update-enrollment`;
    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Enrolled status updated');

      // update local leads (keeps shape intact)
      setLeads(prev => prev.map(r =>
        r.key === enrolledRecord.key ? { ...r, Enrolled: enrolledValue } : r
      ));

      setEnrolledModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update enrolled status';
      toast.error(msg);
    }
  } catch (err) {
    console.error('update-enrollment error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setEnrolledLoading(false);
    setEnrolledSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};


// First Installment Status Modal
const [installmentModalVisible, setInstallmentModalVisible] = useState(false);
const [installmentRecord, setInstallmentRecord] = useState(null);
const [installmentValue, setInstallmentValue] = useState(null);
const [installmentLoading, setInstallmentLoading] = useState(false);

// Track sending state per record
const [installmentSendingKeys, setInstallmentSendingKeys] = useState(new Set());

// Open modal handler
const openInstallmentModal = (record) => {
  setInstallmentRecord(record);
  const cur = (record?.FirstInstallmentStatus ?? '').toString().toUpperCase();
  setInstallmentValue(cur || null);
  setInstallmentModalVisible(true);
};

const handleChangeInstallmentStatus = async () => {
  if (!installmentRecord || !installmentRecord.Email) {
    toast.error('No record selected');
    return;
  }
  if (!installmentValue) {
    toast.error('Select installment status');
    return;
  }

  const keyName = `installment-${installmentRecord.key}`;
  setInstallmentSendingKeys(prev => new Set(prev).add(keyName));
  setInstallmentLoading(true);

  try {
    const payload = {
      Email: installmentRecord.Email,
      FirstInstallmentStatus: installmentValue,
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/update-first-installment-status`;
    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Installment status updated');

      // Update UI immediately
      setLeads(prev =>
        prev.map(r =>
          r.key === installmentRecord.key
            ? { ...r, FirstInstallmentStatus: installmentValue }
            : r
        )
      );

      setInstallmentModalVisible(false);
    } else {
      toast.error(res?.data?.message || 'Failed to update installment status');
    }
  } catch (err) {
    console.error('update-first-installment-status error', err);
    toast.error(err?.response?.data?.message || err?.message || 'Network/server error');
  } finally {
    setInstallmentLoading(false);
    setInstallmentSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};

// modal for installment date
const [installmentDateModalVisible, setInstallmentDateModalVisible] = useState(false);
const [installmentDateRecord, setInstallmentDateRecord] = useState(null);
const [installmentDateValue, setInstallmentDateValue] = useState(null); // dayjs object
const [installmentDateLoading, setInstallmentDateLoading] = useState(false);
const [installmentDateSendingKeys, setInstallmentDateSendingKeys] = useState(new Set());


// --------- Amount Paid (add with other useState declarations) ----------
const [amountModalVisible, setAmountModalVisible] = useState(false);
const [amountRecord, setAmountRecord] = useState(null); // record for which modal opened
const [amountLoading, setAmountLoading] = useState(false);
const [amountValue, setAmountValue] = useState(null);
const [amountSendingKeys, setAmountSendingKeys] = useState(new Set());


const handleAmountPaid = async (record) => {
  if (!record?.Email) {
    toast.error('Record missing Email');
    return;
  }
  if (!amountValue) {
    toast.error('Please select an amount');
    return;
  }

  const keyName = `amount-${record.key}`;
  setAmountSendingKeys(prev => { const next = new Set(prev); next.add(keyName); return next; });
  setAmountLoading(true);

  const payload = {
    Email: record.Email,
    AmountPaid: Number(amountValue), // ensure integer
  };

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/update-amount`;
    const res = await axios.put(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Amount updated');

      // update UI row
      setLeads(prev => prev.map(r => r.key === record.key ? { ...r, AmountPaid: payload.AmountPaid } : r));

      // close modal
      setAmountModalVisible(false);
      setAmountRecord(null);
      setAmountValue(null);
    } else {
      const err = res?.data?.message || 'Failed to update amount';
      toast.error(err);
    }
  } catch (err) {
    console.error('update-amount error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setAmountLoading(false);
    setAmountSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};

// Send Joining Message
const [joiningModalVisible, setJoiningModalVisible] = useState(false);
const [joiningModalLoading, setJoiningModalLoading] = useState(false);
const [joiningRecord, setJoiningRecord] = useState(null);
const [joiningSendingKeys, setJoiningSendingKeys] = useState(new Set());

  const handleSendJoiningMessage = async (record) => {
  if (!record || !record.Email) {
    toast.error('No lead selected or email missing');
    return;
  }

  const keyName = `joining-${record.key}`;
  setJoiningSendingKeys(prev => {
    const next = new Set(prev);
    next.add(keyName);
    return next;
  });
  setJoiningModalLoading(true);

  try {
    const payload = {
      Email: record.Email,
      PhoneNumber: record.PhoneNumber ?? '',
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/send-joining-message`;
    const res = await axios.put(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Joining message sent');

      // update local UI: set JoiningMessage to 'SENT' for that lead
      setLeads(prev => prev.map(r => r.key === record.key ? { ...r, JoiningMessage: 'SENT' } : r));

      // Close modal
      setJoiningModalVisible(false);
      setJoiningRecord(null);
    } else {
      const err = res?.data?.message || 'Failed to send joining message';
      toast.error(err);
    }
  } catch (err) {
    console.error('send-joining-message error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setJoiningModalLoading(false);
    setJoiningSendingKeys(prev => {
      const next = new Set(prev);
      next.delete(keyName);
      return next;
    });
  }
};

  // 🧩 Table Columns
  const columns = [
    {
      title: <span className="text-[17px] font-bold text-white">Full Name</span>,
      dataIndex: 'FullName',
      key: 'FullName',
      width: 240,
      render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white whitespace-nowrap">Email</span>,
      dataIndex: 'Email',
      key: 'Email',
      width: 200,
      render: (t) => <span className="whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Phone Number</span>,
      dataIndex: 'PhoneNumber',
      key: 'PhoneNumber',
      width: 170,
      render: (t) => <span className="ml-4 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Lead Category</span>,
      dataIndex: 'LeadCategory',
      key: 'LeadCategory',
      width: 160,
      render: (t) => <span className="font-bold text-amber-700 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Lead Date</span>,
      dataIndex: 'LeadDate',
      key: 'LeadDate',
      width: 130,
      render: (d) => (
        <span className="font-extrabold text-center text-blue-700 whitespace-nowrap">
          {safe(d)}
        </span>
      ),
    },
    {
      title: <span className="text-[17px] font-bold text-white">Lead Source</span>,
      dataIndex: 'LeadSource',
      key: 'LeadSource',
      width: 210,
      render: (t) => <span className="ml-4 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Enrolled Batch</span>,
      dataIndex: 'EnrolledBatch',
      key: 'EnrolledBatch',
      width: 160,
      render: (t) => <span className="font-bold text-green-700 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Batch Day</span>,
      dataIndex: 'BatchDay',
      key: 'BatchDay',
      width: 160,
      render: (t) => <span className="ml-5 font-bold text-red-600 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Enrollment Type</span>,
      dataIndex: 'EnrollmentType',
      key: 'EnrollmentType',
      width: 240,
      render: (t) => <span className="font-bold text-pink-950 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Batch Start Date</span>,
      dataIndex: 'BatchStartDate',
      key: 'BatchStartDate',
      width: 190,
      render: (t) => <span className="font-bold ml-7 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Negotiated Fee</span>,
      dataIndex: 'NegotiatedFee',
      key: 'NegotiatedFee',
      width: 180,
      render: (t) => <span className="ml-6 font-bold text-violet-700 whitespace-nowrap">{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Installment</span>,
      dataIndex: 'Installment',
      key: 'Installment',
      width: 130,
      render: (t) => (
        <span
          className={`ml-5  whitespace-nowrap font-bold ${
            String(t).toUpperCase() === 'YES' ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {safe(t)}
        </span>
      ),
    },
    {
  title: <span className="text-[17px] font-bold text-white">Payment Link</span>,
  dataIndex: 'PaymentLink_1',
  key: 'PaymentLink_1',
  width: 200,
  align: 'center',
  render: (t, record) => {
    const status = String(record?.PaymentLink_1 ?? 'PENDING').toUpperCase();
    const isSent = status === 'SENT';
    const keyName = `payment-${record.key}`;
    const isSending = paymentSendingKeys.has(keyName);

    // colors inline so AntD button displays properly across themes
    const style = isSending
      ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' }
      : isSent
      ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' } // green
      : { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' }; // red

    return (
      <div className="flex justify-center">
        <button
          onClick={() => openPaymentModal(record)}
          disabled={isSending}
          style={{
            ...style,
            minWidth: 160,
            
          }}
className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm transition-all duration-150"
        >
          {isSending ? (
            <span className="inline-flex items-center gap-2">
              <Spin size="small" />
              Sending...
            </span>
          ) : isSent ? (
            'Payment Link Sent'
          ) : (
            'Send Payment Link'
          )}
        </button>
      </div>
    );
  },
},

    {
      title: <span className="text-[17px] font-bold text-white">PaymentLink_1</span>,
      dataIndex: 'PaymentLink_1',
      key: 'PaymentLink_1',
      width: 160,
      render: (t) => <span className={`ml-7 whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">PaymentLink_2</span>,
      dataIndex: 'PaymentLink_2',
      key: 'PaymentLink_2',
      width: 160,
      render: (t) => <span className={`whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">PaymentLink_3</span>,
      dataIndex: 'PaymentLink_3',
      key: 'PaymentLink_3',
      width: 160,
      render: (t) => <span className={`whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span>,
    },
    {
  title: <span className="text-[17px] font-bold text-white">Call Status</span>,
  dataIndex: 'CallStatus',
  key: 'CallStatus',
  width: 160,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? '').toUpperCase();
    // treat REQUIRED or PENDING as "needs action" (red); others green
    const isAlert = status === 'REQUIRED' || status === 'PENDING';
    const isSending = callStatusSendingKeys.has(`callstatus-${record.key}`);

    const style = isSending
      ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' }
      : isAlert
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' }
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' };

    return (
      <div className="flex justify-center">
        <button
          onClick={() => openCallStatusModal(record)}
          disabled={isSending}
          style={{
            ...style,
            minWidth: 110,
          
          }}
className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm transition-all duration-150"
          type="button"
        >
          {isSending ? (
            <span className="inline-flex items-center gap-2">
              <Spin size="small" />
              Updating...
            </span>
          ) : (
            (status && status !== 'NULL') ? status : 'Change'
          )}
        </button>
      </div>
    );
  },
},
{
  title: <span className="text-[17px] font-bold text-white">Comment</span>,
  dataIndex: "Comment",
  key: "Comment",
  width: 360,
  align: "center",
  render: (t, record) => {
    const comment = t || "No comment";
    const keyName = `comment-${record.key}`;
    const isSending = commentSendingKeys.has(keyName);

    return (
      <div className="flex flex-col items-center gap-2">
        <span className="max-w-[290px] truncate text-sm font-semibold text-gray-700">
          {comment}
        </span>

        <Button
          size="small"
          type="primary"
          loading={isSending}
          onClick={() => {
            setCommentRecord(record);
            setCommentValue(record?.Comment || "");
            setCommentModalVisible(true);
          }}
          className="!bg-purple-700 hover:!bg-purple-900 !font-bold"
        >
          Update
        </Button>
      </div>
    );
  },
},

    {
  title: <span className="text-[17px] font-bold text-white">Enrolled Status</span>,
  dataIndex: 'Enrolled',
  key: 'Enrolled',
  width: 200,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? '').toUpperCase();
    const isPending = status === 'PENDING' || status === '' || status === 'NULL';
    const isSending = enrolledSendingKeys.has(`enrolled-${record.key}`);

    const style = isSending
      ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' }
      : isPending
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } // red for pending
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }; // green if set

    const label = isPending ? 'Set Enrolled Status' : (status || 'Change');

    return (
      <div className="flex justify-center">
        <button
          onClick={() => openEnrolledModal(record)}
          disabled={isSending}
          style={{
            ...style,
            minWidth: 90,
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm transition-all duration-150"
          type="button"
        >
          {isSending ? (
            <span className="inline-flex items-center gap-2">
              <Spin size="small" />
              Updating...
            </span>
          ) : (
            label
          )}
        </button>
      </div>
    );
  },
},

    
    {
  title: <span className="text-[17px] font-bold text-white">First Installment Status</span>,
  dataIndex: 'FirstInstallmentStatus',
  key: 'FirstInstallmentStatus',
  width: 290,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? 'UNPAID').toUpperCase();
    const isUnpaid = status === 'UNPAID' || status === '' || status === 'NULL';
    const isSending = installmentSendingKeys.has(`installment-${record.key}`);

    const style = isSending
      ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' }
      : isUnpaid
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } // red
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }; // green

    const label = isUnpaid ? 'Set Installment Status' : status;

    return (
      <div className="flex justify-center">
        <button
          onClick={() => openInstallmentModal(record)}
          disabled={isSending}
          style={{
            ...style,
            minWidth: 90,
           
          }}
         className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm transition-all duration-150"
          type="button"
        >
          {isSending ? (
            <span className="inline-flex items-center gap-2">
              <Spin size="small" /> Updating...
            </span>
          ) : (
            label
          )}
        </button>
      </div>
    );
  },
},

    {
  title: <span className="text-[17px] font-bold text-white">First Installment Paid Date</span>,
  dataIndex: 'FirstInstallmentDate',
  key: 'FirstInstallmentDate',
  width: 330,
  align: 'center',
  render: (t, record) => {
    const value = t && t !== '-' ? String(t) : '-';
    const keyName = `installmentDate-${record.key}`;
    const isSending = installmentDateSendingKeys.has(keyName);

    if (!value || value === '-') {
      // show button to set date (red)
      return (
        <div className="flex justify-center">
          <button
            onClick={() => {
              // open modal and preselect record
              setInstallmentDateRecord(record);
              setInstallmentDateValue(null);
              setInstallmentDateModalVisible(true);
            }}
            disabled={isSending}
            style={{
              backgroundColor: isSending ? '#9CA3AF' : '#dc2626',
              color: '#fff',
             
              minWidth: 190,
            }}
          className="px-3 py-1.5 rounded-md font-bold whitespace-nowrap shadow-sm transition-all duration-150"
            type="button"
          >
            {isSending ? 'Processing...' : 'Set Installment Date'}
          </button>
        </div>
      );
    }

    // show formatted date with small "Change" button to edit
    return (
      <div className="flex items-center justify-center gap-3">
        <span className="font-bold text-green-700 whitespace-nowrap">{safe(value)}</span>
        <button
          onClick={() => {
            // try parse existing date (if already in dd-mm-yyyy or ISO)
            let parsed = null;
            try {
              // accept dd-MM-YYYY or ISO
              if (/\d{2}-\d{2}-\d{4}/.test(value)) {
                parsed = dayjs(value, 'DD-MM-YYYY');
              } else {
                parsed = dayjs(value);
              }
              if (!parsed || !parsed.isValid()) parsed = null;
            } catch (e) {
              parsed = null;
            }
            setInstallmentDateRecord(record);
            setInstallmentDateValue(parsed);
            setInstallmentDateModalVisible(true);
          }}
          className="px-3 py-1 font-medium text-gray-900 border-2 border-black rounded-md bg-amber-400"
          type="button"
        >
          Change
        </button>
      </div>
    );
  },
},
  {
  title: (
    <span className="text-[17px] font-bold text-white">
      Amount Paid
    </span>
  ),

  dataIndex: "AmountPaid",

  key: "AmountPaid",

  width: 240,

  align: "center",

  render: (t, record) => {

    const safeVal =
      t === null ||
      t === undefined ||
      t === ""
        ? "-"
        : t;

    const keyName =
      `amount-${record.key}`;

    const isSending =
      amountSendingKeys.has(keyName);

    return (

      <div className="flex flex-row items-center gap-2">

        {/* AMOUNT */}

        {safeVal === "-" ? (

         <span></span>

        ) : (

          <span className="text-sm font-bold text-green-700 whitespace-nowrap">

            ₹{Number(safeVal).toLocaleString("en-IN")}/-

          </span>

        )}

        {/* CHANGE BUTTON */}

        <button
          onClick={() => {

            setAmountRecord(record);

            setAmountValue(
              safeVal !== "-"
                ? safeVal
                : null
            );

            setAmountModalVisible(true);

          }}

          disabled={isSending}

          className={`px-4 py-1.5 rounded-md text-white font-semibold text-sm transition-all duration-150 ${
            isSending
              ? "bg-gray-400 cursor-wait"
              : safeVal === "-"
              ? "bg-red-600 hover:bg-red-700"
              : "bg-blue-700 hover:bg-blue-800"
          }`}
        >

          {isSending
            ? "Processing..."
            : safeVal === "-"
            ? "Update Amount"
            : "Change"}

        </button>

      </div>

    );

  },
},
   {
  title: <span className="text-[17px] font-bold text-white">Joining Message</span>,
  dataIndex: 'JoiningMessage',
  key: 'JoiningMessage',
  width: 220,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? 'PENDING').toUpperCase();
    const isSent = status === 'SENT';
    const keyName = `joining-${record.key}`;
    const isSending = joiningSendingKeys.has(keyName);

    if (isSent) {
      return (
        <div className="flex justify-center">
          <button
            type="button"
            onClick={() => {
              // allow resend as text "Joining Message Sent (Resend)" if you want:
              setJoiningRecord(record);
              setJoiningModalVisible(true);
            }}
            className="px-4 py-2 font-semibold text-white bg-green-600 rounded-md hover:bg-green-700 whitespace-nowrap"
          >
            Joining Message Sent
          </button>
        </div>
      );
    }

    // PENDING (default) -> send button (red)
    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setJoiningRecord(record);
            setJoiningModalVisible(true);
          }}
          disabled={isSending}
          className={`px-4 py-2 rounded-md text-white font-semibold whitespace-nowrap ${
            isSending ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'
          }`}
        >
          {isSending ? <span className="inline-flex items-center gap-2"><Spin size="small" />Sending...</span> : 'Send Joining Message'}
        </button>
      </div>
    );
  },
},
     {
      title: (
        <span className="font-bold text-[17px] text-white whitespace-nowrap">
          Action
        </span>
      ),
      key: 'action',
      fixed: 'right',
      width: 200,
      align: 'center',
      render: (_, record) => {
        return (
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => openActionModal(record)}
              className={`px-4 py-2 rounded-md text-white font-semibold transition-colors duration-200 whitespace-nowrap bg-gradient-to-r from-blue-600 to-blue-500 hover:from-red-700 hover:to-rose-600 shadow`}
              type="button"
            >
              Actions
            </button>
          </div>
        );
      },
    }
  ];

   const demoLinksColumns = [
    { title: 'DemoDate', dataIndex: 'DemoDate', key: 'DemoDate', width: 140, render: (d) => <span className="font-bold whitespace-nowrap">{safe(d)}</span> },
    { title: 'Day', dataIndex: 'Day', key: 'Day', width: 80, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Month', dataIndex: 'Month', key: 'Month', width: 100, render: (t) => <span className="font-bold text-amber-600 whitespace-nowrap">{safe(t)}</span> },
    { title: 'Year', dataIndex: 'Year', key: 'Year', width: 100, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Time', dataIndex: 'Time', key: 'Time', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchStartDate', dataIndex: 'BatchStartDate', key: 'BatchStartDate', width: 140, render: (d) => <span className="font-bold text-green-600 whitespace-nowrap">{safe(d)}</span> },
    { title: 'BatchDay', dataIndex: 'BatchDay', key: 'BatchDay', width: 100, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchTime', dataIndex: 'BatchTime', key: 'BatchTime', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'DemoLink', dataIndex: 'DemoLink', key: 'DemoLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
    { title: 'DemoRecordingLink', dataIndex: 'DemoRecordingLink', key: 'DemoRecordingLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
  ];

  // Put near other useState hooks at top of component
const [filterFullNameText, setFilterFullNameText] = useState('');
const [filterEmailText, setFilterEmailText] = useState('');
const [filterCategory, setFilterCategory] = useState(null); // STUDENT / PROFESSIONAL
const [filterSources, setFilterSources] = useState([]); // multi
const [filterAvailabilityMonth, setFilterAvailabilityMonth] = useState(null); // JANUARY etc
const [filterBatchDays, setFilterBatchDays] = useState([]); // MORNING / EVENING multi
const [filterCallStatus, setFilterCallStatus] = useState(null); // REQUIRED / NOT REQUIRED / PERFORMED
const [filterEnrollmentType, setFilterEnrollmentType] = useState(null); // JUNIOR / SENIOR
const [filterInstallment, setFilterInstallment] = useState(null); // YES/NO
const [filterEnrolled, setFilterEnrolled] = useState(null); // PENDING/YES/NO
const [filterFirstInstallmentStatus, setFilterFirstInstallmentStatus] = useState(null); // UNPAID/PAID

// helper to normalize comparisons
const normalize = (v) => {
  if (v === null || v === undefined) return '';
  return String(v).trim().toUpperCase();
};

// Extract month name from AvailabilityBatch like "26-OCTOBER-2025" or "26-OCT-2025" (basic)
const monthFromAvailability = (avail) => {
  if (!avail && avail !== 0) return '';

  // Normalize to uppercase string and replace common separators with spaces
  const s = String(avail).toUpperCase().replace(/[.,_\/]+/g, ' ').trim();

  // Full month names (uppercase)
  const MONTHS_FULL = [
    'JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE',
    'JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'
  ];

  // Map 3-letter abbreviations to full names
  const ABBR_TO_FULL = {
    'JAN':'JANUARY','FEB':'FEBRUARY','MAR':'MARCH','APR':'APRIL','MAY':'MAY','JUN':'JUNE',
    'JUL':'JULY','AUG':'AUGUST','SEP':'SEPTEMBER','SEPT':'SEPTEMBER','OCT':'OCTOBER','NOV':'NOVEMBER','DEC':'DECEMBER'
  };

  // 1) Check for any full month name in the string
  for (const m of MONTHS_FULL) {
    if (s.includes(m)) return m;
  }

  // 2) Check for abbreviation as whole token (JAN, FEB, OCT etc)
  const abbrMatch = s.match(/\b(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|SEPT|OCT|NOV|DEC)\b/);
  if (abbrMatch && ABBR_TO_FULL[abbrMatch[1]]) return ABBR_TO_FULL[abbrMatch[1]];

  // 3) Check for numeric month like 01,1,10,12 etc (often appears as part of date)
  const numMatch = s.match(/\b(0?[1-9]|1[0-2])\b/);
  if (numMatch) {
    const n = parseInt(numMatch[1], 10);
    if (n >= 1 && n <= 12) return MONTHS_FULL[n - 1];
  }

  // Nothing matched
  return '';
};


// clear all filters
const clearFilters = () => {
  setFilterFullNameText('');
  setFilterEmailText('');
  setFilterCategory(null);
  setFilterSources([]);
  setFilterAvailabilityMonth(null);
  setFilterBatchDays([]);
  setFilterCallStatus(null);
  setFilterEnrollmentType(null);
  setFilterInstallment(null);
  setFilterEnrolled(null);
  setFilterFirstInstallmentStatus(null);
};

// filteredLeads - returns new array, DOES NOT mutate leads
const filteredLeads = useMemo(() => {
  if (!Array.isArray(leads)) return [];

  const fname = normalize(filterFullNameText);
  const femail = normalize(filterEmailText);
  const catF = normalize(filterCategory); // '' if null
  const sourcesF = (filterSources || []).map(s => normalize(s));
  const batchDaysF = (filterBatchDays || []).map(d => normalize(d));
  const availMonthF = normalize(filterAvailabilityMonth);
  const callF = normalize(filterCallStatus);
  const enrollTypeF = normalize(filterEnrollmentType);
  const installmentF = normalize(filterInstallment);
  const enrolledF = normalize(filterEnrolled);
  const firstInstF = normalize(filterFirstInstallmentStatus);

  return leads.filter((r) => {
    // Full name search (contains)
    if (fname) {
      const v = normalize(r.FullName || '');
      if (!v.includes(fname)) return false;
    }

    // Email search (contains)
    if (femail) {
      const v = normalize(r.Email || '');
      if (!v.includes(femail)) return false;
    }

    // Category exact (if selected)
    if (catF) {
      const v = normalize(r.LeadCategory || '');
      if (v !== catF) return false;
    }

    // Sources (multi): if provided, record's LeadSource must be one of them
    if (sourcesF.length) {
      const v = normalize(r.LeadSource || '');
      if (!sourcesF.includes(v)) return false;
    }

    // Availability month (extract from AvailabilityBatch field)
   if (availMonthF) {
  const month = monthFromAvailability(r.EnrolledBatch);
  if (!month) return false;
  if (normalize(month) !== availMonthF) return false;
}
 
    // Batch day multi
    if (batchDaysF.length) {
      const bd = normalize(r.BatchDay || '');
      if (!batchDaysF.includes(bd)) return false;
    }

    // Call Status single
    if (callF) {
      const v = normalize(r.CallStatus || '');
      if (v !== callF) return false;
    }

    // Enrollment Type
    if (enrollTypeF) {
      const v = normalize(r.EnrollmentType || '');
      if (v !== enrollTypeF) return false;
    }

    // Installment YES/NO
    if (installmentF) {
      const v = normalize(r.Installment || '');
      if (v !== installmentF) return false;
    }

    // Enrolled
    if (enrolledF) {
      const v = normalize(r.Enrolled || '');
      if (v !== enrolledF) return false;
    }

    // FirstInstallmentStatus
    if (firstInstF) {
      const v = normalize(r.FirstInstallmentStatus || '');
      if (v !== firstInstF) return false;
    }

   

    return true;
  });
}, [
  leads,
  filterFullNameText,
  filterEmailText,
  filterCategory,
  filterSources,
  filterAvailabilityMonth,
  filterBatchDays,
  filterCallStatus,
  filterEnrollmentType,
  filterInstallment,
  filterEnrolled,
  filterFirstInstallmentStatus
  
]);

  let juniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'JUNIOR PENETRATION TESTER'
  })

  let seniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'SENIOR PENETRATION TESTER'
  })

  let studentFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'STUDENT'
  })

  let professionalFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'PROFESSIONAL'
  })

  return (
    <div className="w-full px-6 py-8 mx-auto bg-white shadow-sm rounded-xl">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        className="!mb-6 !ml-4"
        toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
      />

      <Title
        level={3}
        className="!text-3xl !font-bold text-gray-800 tracking-tight mb-3 border-b border-gray-200 pb-2"
      >
        First Installments
      </Title>

      <Paragraph className="mb-6 text-base leading-relaxed text-gray-700">
        This section lists all leads that have reached the First Installment stage. You can review their
        enrollment, batch details, payment status, and other important details.
      </Paragraph>

       <p className="text-lg text-slate-700">
                    You can access all lead details anytime from the{" "}
                    <Link
                      to={fullPath}
                      className="inline-flex items-center gap-2 px-3 py-1 text-lg font-semibold text-red-600 bg-gray-100 rounded-md hover:bg-gray-200"
                    >
                      First Installment Dashboard
                    </Link>
                  </p>

      {error && (
        <Alert
          type="error"
          message="Error"
          description={error}
          showIcon
          closable
          className="mb-6"
        />
      )}

      <div className="w-full mt-6">
            {/* Filters */}
          {/* FILTER TOGGLE BUTTON */}
          <div className="flex justify-end mb-3">
            <Button
              onClick={() => setShowFilters(!showFilters)}
              type="primary"
              className="
                font-bold
                px-5
                rounded-lg
                bg-gradient-to-r
                from-blue-700
                via-indigo-700
                to-purple-700
                border-none
                text-white
                shadow-[0_0_20px_rgba(79,70,229,0.8)]
                hover:shadow-[0_0_35px_rgba(79,70,229,1)]
                hover:scale-105
                animate-pulse
                transition-all
                duration-300
              "
            >
              {showFilters ? "Hide Filters" : "Show Filters"}
            </Button>
          </div>
          
          {/* Filters with transition */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              showFilters
                ? "max-h-[900px] opacity-100 translate-y-0 mb-3"
                : "max-h-0 opacity-0 -translate-y-3 mb-0"
            }`}
          >
          <div className="p-5 border border-slate-400 shadow-[0_10px_35px_rgba(15,23,42,0.12)] bg-gradient-to-br from-white via-slate-50 to-blue-50 rounded-2xl">
          
          
  <div className="flex items-center gap-3 my-6 ml-4">
    {/* FullName Search */}
    <div className="flex items-center gap-2">
      <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">Full Name</label>
      <Search
        placeholder="Search Full Name"
        allowClear
        value={filterFullNameText}
        onChange={(e) => setFilterFullNameText(e.target.value)}
        onSearch={(v) => setFilterFullNameText(v)}
        style={{ minWidth: 260, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
        enterButton={false}
      />
    </div>

    {/* Email Search */}
    <div className="flex items-center gap-2">
      <label className="text-sm font-semibold text-gray-700">Email</label>
      <Search
        placeholder="Search email"
        allowClear
        value={filterEmailText}
        onChange={(e) => setFilterEmailText(e.target.value)}
        onSearch={(v) => setFilterEmailText(v)}
        style={{ minWidth: 260, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
        enterButton={false}
      />
    </div>

    <div className="flex-grow ml-4 border-2 border-t border-gray-400"></div>
  </div>

  {/* Filters toolbar */}
  <div className="flex flex-col gap-4 mb-7 md:flex-row md:items-center md:justify-between">
    <div className="flex flex-wrap items-center gap-3">

      {/* Lead Category */}
      <div className="flex items-center gap-2 ml-4">
        <label className="text-sm font-semibold text-gray-700">Lead Category</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>All</span>}
          value={filterCategory}
          onChange={(v) => setFilterCategory(v || null)}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'Student', value: 'STUDENT' }, { label: 'Professional', value: 'PROFESSIONAL' } ]}
        />
      </div>

      {/* Lead Source (multi) */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Lead Source</label>
        <Select
          mode="multiple"
          placeholder={<span style={{ color: '#4b5563' }}>Select Source</span>}
          value={filterSources}
          onChange={(v) => setFilterSources(v || [])}
          allowClear
          style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'Google', value: 'GOOGLE' }, 
            { label: 'Meta', value: 'META' }, 
            { label: 'Meta-Instagram', value: 'META-INSTAGRAM' },
             { label: 'Meta-Facebook', value: 'META-FACEBOOK' },
            { label: 'LinkedIn', value: 'LINKEDIN' },
            { label: 'Organic', value: 'ORGANIC' }, 
            { label: 'Youtube', value: 'YOUTUBE' },
           { label: 'Youtube-Infeed', value: 'YOUTUBE-YIF' },
                       { label: 'Youtube-Instream', value: 'YOUTUBE-YIS' },
                       ]}
        />
      </div>

      {/* Availability Month */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Availability Month</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Select Month</span>}
          value={filterAvailabilityMonth}
          onChange={(v) => setFilterAvailabilityMonth(v || null)}
          allowClear
          style={{ minWidth: 140, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'JANUARY', value: 'JANUARY' }, { label: 'FEBRUARY', value: 'FEBRUARY' }, { label: 'MARCH', value: 'MARCH' },
            { label: 'APRIL', value: 'APRIL' }, { label: 'MAY', value: 'MAY' }, { label: 'JUNE', value: 'JUNE' },
            { label: 'JULY', value: 'JULY' }, { label: 'AUGUST', value: 'AUGUST' }, { label: 'SEPTEMBER', value: 'SEPTEMBER' },
            { label: 'OCTOBER', value: 'OCTOBER' }, { label: 'NOVEMBER', value: 'NOVEMBER' }, { label: 'DECEMBER', value: 'DECEMBER' },
          ]}
        />
      </div>

      {/* Batch Day (multi) */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Batch Day</label>
        <Select
          mode="multiple"
          placeholder={<span style={{ color: '#4b5563' }}>Select Batch Day</span>}
          value={filterBatchDays}
          onChange={(v) => setFilterBatchDays(v || [])}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'Morning', value: 'MORNING' }, { label: 'Evening', value: 'EVENING' } ]}
        />
      </div>

      {/* Call Status */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Call Status</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterCallStatus}
          onChange={(v) => setFilterCallStatus(v || null)}
          allowClear
          style={{ minWidth: 140, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'REQUIRED', value: 'REQUIRED' }, { label: 'NOT REQUIRED', value: 'NOT REQUIRED' }, { label: 'PERFORMED', value: 'PERFORMED' } ]}
        />
      </div>

      {/* Enrollment Type */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Enrollment Type</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterEnrollmentType}
          onChange={(v) => setFilterEnrollmentType(v || null)}
          allowClear
          style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' }, { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' } ]}
        />
      </div>

      {/* Installment */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Installment</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterInstallment}
          onChange={(v) => setFilterInstallment(v || null)}
          allowClear
          style={{ minWidth: 120, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'YES', value: 'YES' }, { label: 'NO', value: 'NO' } ]}
        />
      </div>

      {/* Enrolled */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Enrolled</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterEnrolled}
          onChange={(v) => setFilterEnrolled(v || null)}
          allowClear
          style={{ minWidth: 140, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'PENDING', value: 'PENDING' }, { label: 'YES', value: 'YES' }, { label: 'NO', value: 'NO' } ]}
        />
      </div>

      {/* First Installment Status */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">First Installment Status</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterFirstInstallmentStatus}
          onChange={(v) => setFilterFirstInstallmentStatus(v || null)}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[ { label: 'UNPAID', value: 'UNPAID' }, { label: 'PAID', value: 'PAID' } ]}
        />
      </div>

     

      {/* Clear Filters button */}
      <div className="ml-4">
        <Button onClick={clearFilters} icon={<UndoOutlined />} type="default" className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-50">
          Clear Filters
        </Button>
      </div>

    </div>
  </div>
</div>
</div>

 <div className="flex items-center gap-4 mb-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Total Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {filteredLeads.length}
    </div>
  </div> 

  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Student Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {studentFilter.length}
    </div>
  </div> 

<div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Professional Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {professionalFilter.length}
    </div>
  </div> 
  
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Junior
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {juniorFilter.length}
    </div>
  </div> 

  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Senior
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {seniorFilter.length}
    </div>
  </div> 
  
</div>


      <Table
        dataSource={filteredLeads}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 25, total: filteredLeads.length }}
        scroll={{ x: 3500 }}
         className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table-first"
        
      />

</div>

      {/* Action Modal */}
                  <Modal
                    title={<div className="flex items-center justify-center w-full"><span className="text-xl font-bold text-gray-900">Choose action for lead</span></div>}
                    open={actionModalVisible}
                    onCancel={() => setActionModalVisible(false)}
                    footer={null}
                    centered
                    width={520}
                    bodyStyle={{ padding: 24 }}
                  >
                    <div className="space-y-4">
                      <div className="text-sm text-gray-700">
                        Performing action for: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
                        {actionRecord?.PhoneNumber ? <span className="ml-2 text-xs font-semibold text-gray-700">({actionRecord.PhoneNumber})</span> : null}
                      </div>
            
                      <div className="flex flex-col gap-3">
                        <button onClick={() => handleMoveToPendingInstallment(actionRecord)} disabled={!actionRecord || movingKeys.has(`move-pending-installment-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-pending-installment-${actionRecord?.key}`) ? 'bg-blue-400 cursor-wait' : 'bg-blue-600 hover:bg-blue-700'}`} type="button">
                          {movingKeys.has(`move-pending-installment-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To Pending Installment Stage'}
                        </button>

                        <button
  onClick={() => handleMoveToEnrollments(actionRecord)}
  disabled={
    !actionRecord ||
    movingKeys.has(`move-enrollment-${actionRecord?.key}`)
  }
  className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${
    movingKeys.has(`move-enrollment-${actionRecord?.key}`)
      ? "bg-green-400 cursor-wait"
      : "bg-green-600 hover:bg-green-700"
  }`}
  type="button"
>
  {movingKeys.has(`move-enrollment-${actionRecord?.key}`) ? (
    <span className="inline-flex items-center gap-2">
      <Spin size="small" />
      Moving...
    </span>
  ) : (
    "Move To Enrollments Stage"
  )}
</button>
            
                       {/* Move to Upcoming Batch */}
            <button
              onClick={() => openUpcomingModal(actionRecord)}
              disabled={!actionRecord || movingKeys.has(`move-upcoming-${actionRecord?.key}`)}
              className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? 'bg-indigo-400 cursor-wait' : 'bg-gray-600 hover:bg-gray-900'}`}
              type="button"
            >
              {movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
            </button>
            
                        <button onClick={() => { setDropComments(''); setDropModalVisible(true); }} disabled={!actionRecord || movingKeys.has(`drop-lead-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`drop-lead-${actionRecord?.key}`) ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button">
                          Drop The Lead
                        </button>
                      </div>
                    </div>
                  </Modal>
            
                  {/* Upcoming Batch Modal */}
            <Modal
              title={<span className="text-lg font-bold">Move To Upcoming Batch</span>}
              open={upcomingModalVisible}
              onCancel={() => setUpcomingModalVisible(false)}
              footer={null}
              centered
              width={1000}
            >
              <div className="space-y-4">
                <div className="text-gray-800 text-md">
                  Moving lead : <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
                </div>
                  <div className="mb-2 text-sm text-gray-800">
                  Current Batch : <strong className='text-red-800'>{actionRecord?.EnrolledBatch ?? '-'}</strong>
                </div>
                <div className="mb-4 text-sm text-gray-800">
                  Batch day : <strong className='text-green-800'>{actionRecord?.BatchDay ?? '-'}</strong>
                </div>
            
                <div>
                  <label className="block mb-1 text-gray-800 text-md">Email</label>
                  <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 font-semibold bg-gray-100 border border-gray-200 rounded-md text-md" />
                </div>
            
                <div>
                  <label className="block mb-2 text-gray-800 text-md">Select Batch (choose one)</label>
            
                  {upcomingModalLoading ? (
                    <div className="flex items-center justify-center py-8"><Spin /></div>
                  ) : (
                    <Table
                      dataSource={upcomingDemoLinks}
                      columns={demoLinksColumns}
                      rowKey={(r) => r.key}
                      pagination={{ pageSize: 15 }}
                      size="small"
                      className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
                      scroll={{ x: 1400 }}
                      rowSelection={{
                        type: 'radio',
                        selectedRowKeys: selectedUpcomingDemoKey ? [selectedUpcomingDemoKey] : [],
                        onChange: (keys, rows) => {
                          setSelectedUpcomingDemoKey(keys && keys[0] ? keys[0] : null);
                        }
                      }}
                      onRow={(rec) => ({
                        onClick: () => handleSelectUpcomingRow(rec),
                        tabIndex: 0,
                        onKeyDown: (e) => {
                          if (e.key === 'Enter' || e.key === ' ') handleSelectUpcomingRow(rec);
                        }
                      })}
                    />
                  )}
                </div>
            
                <div>
                  <label className="block mb-1 text-gray-800 text-md">Comments</label>
                  <TextArea rows={3} value={upcomingComments} onChange={(e) => setUpcomingComments(e.target.value)} placeholder="Please give comments..." />
                </div>
            
                <div className="flex items-center justify-end gap-3">
                  <Button onClick={() => setUpcomingModalVisible(false)} disabled={upcomingModalLoading}>Cancel</Button>
            
                  <Button
                    type="primary"
                    onClick={handleConfirmMoveToUpcomingBatch}
                    disabled={!selectedUpcomingDemoKey || Boolean(upcomingModalLoading) || Boolean(upcomingMovingKey)}
                    className="bg-blue-600"
                  >
                    {(Boolean(upcomingMovingKey) || upcomingModalLoading) ? <span className="inline-flex items-center gap-2 font-semibold"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
                  </Button>
                </div>
              </div>
            </Modal>
            
            
                  {/* Drop Modal */}
                  <Modal
                    title={<span className="text-lg font-bold">Drop Lead</span>}
                    visible={dropModalVisible}
                    onCancel={() => setDropModalVisible(false)}
                    footer={null}
                    centered
                    width={560}
                  >
                    <div className="space-y-4">
                      <div className="text-sm text-gray-700">Dropping lead: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong></div>
            
                      <div>
                        <label className="block mb-1 text-sm text-gray-700">Email</label>
                        <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border border-gray-200 rounded-md" />
                      </div>
            
                      <div>
                        <label className="block mb-1 text-sm text-gray-700">Comments</label>
                        <TextArea value={dropComments} onChange={(e) => setDropComments(e.target.value)} rows={4} placeholder="Reason / notes for dropping this lead..." />
                      </div>
            
                      <div className="flex items-center justify-end gap-3">
                        <button onClick={() => setDropModalVisible(false)} className="px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-md" type="button" disabled={dropLoading}>Cancel</button>
                        <button onClick={() => handleDropLeadConfirm(actionRecord)} className={`px-5 py-2.5 rounded-md text-white font-semibold ${dropLoading ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button" disabled={dropLoading}>
                          {dropLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Dropping...</span> : 'Drop Lead'}
                        </button>
                      </div>
                    </div>
                  </Modal>

      <Modal
  title={<span className="text-lg font-bold">Send Payment Link</span>}
  visible={paymentModalVisible}
  onCancel={() => setPaymentModalVisible(false)}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="text-sm text-gray-700">
      Sending payment link to : <strong>{selectedPaymentRecord?.FullName ?? '-'}</strong>
      <div className="text-xs text-gray-500">{selectedPaymentRecord?.Email ?? '-'}</div>
    </div>

    <div>
      <label className="block mb-1 text-sm text-gray-600">Email</label>
      <input readOnly value={selectedPaymentRecord?.Email ?? ''} className="w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-md" />
    </div>

    <div>
      <label className="block mb-1 text-sm text-gray-600">Phone Number</label>
      <input readOnly value={selectedPaymentRecord?.PhoneNumber ?? ''} className="w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-md" />
    </div>

    <div className="flex items-center justify-end gap-3">
      <button onClick={() => setPaymentModalVisible(false)} className="px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-md" disabled={paymentModalLoading}>
        Cancel
      </button>

      <button
        onClick={() => handleSendPaymentLink(selectedPaymentRecord)}
        className={`px-5 py-2.5 rounded-md text-white font-semibold ${paymentModalLoading ? 'bg-gray-400 cursor-wait' : 'bg-blue-600 hover:bg-blue-700'}`}
        disabled={paymentModalLoading}
      >
        {paymentModalLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Sending...</span> : 'Send Payment Link'}
      </button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Call Status</span>}
  visible={callStatusModalVisible}
  onCancel={() => setCallStatusModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
     <div className="text-sm text-gray-700">
      Change Call Status to : <strong className="text-sm text-red-700">{callStatusRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={callStatusRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Call Status</label>
      <Select
        value={callStatusValue}
        onChange={(v) => setCallStatusValue(v)}
        placeholder="Select call status"
        style={{ width: '100%' }}
        options={[
          { label: 'PERFORMED', value: 'PERFORMED' },
          { label: 'NOT REQUIRED', value: 'NOT REQUIRED' },
          { label: 'REQUIRED', value: 'REQUIRED' },
        ]}
        disabled={callStatusLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setCallStatusModalVisible(false)} disabled={callStatusLoading}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleUpdateCallStatus}
        disabled={callStatusLoading || !callStatusValue}
        className="bg-blue-600"
      >
        {callStatusLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Call Status'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Enrolled Status</span>}
  visible={enrolledModalVisible}
  onCancel={() => setEnrolledModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div className="text-sm text-gray-700">
      Change Enrolled Status to : <strong className="text-sm text-red-700">{enrolledRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={enrolledRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Enrolled</label>
      <Select
        value={enrolledValue}
        onChange={(v) => setEnrolledValue(v)}
        placeholder="Select Enrolled status"
        style={{ width: '40%' }}
        options={[
          { label: 'YES', value: 'YES' },
          { label: 'NO', value: 'NO' },
          { label: 'PENDING', value: 'PENDING' },
        ]}
        disabled={enrolledLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setEnrolledModalVisible(false)} disabled={enrolledLoading}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleChangeEnrolledStatus}
        disabled={enrolledLoading || !enrolledValue}
        className="bg-blue-600"
      >
        {enrolledLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Enrolled Status'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Installment Status</span>}
  visible={installmentModalVisible}
  onCancel={() => setInstallmentModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
     <div className="text-sm text-gray-700">
      Change First Installment Status to : <strong className="text-sm text-red-700">{installmentRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={installmentRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">First Installment Status</label>
      <Select
        value={installmentValue}
        onChange={(v) => setInstallmentValue(v)}
        placeholder="Select status"
        style={{ width: '40%' }}
        options={[
          { label: 'PAID', value: 'PAID' },
          { label: 'UNPAID', value: 'UNPAID' },
        ]}
        disabled={installmentLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setInstallmentModalVisible(false)} disabled={installmentLoading}>
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={handleChangeInstallmentStatus}
        disabled={installmentLoading || !installmentValue}
        className="bg-blue-600"
      >
        {installmentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Changing...
          </span>
        ) : (
          'Change Installment Status'
        )}
      </Button>
    </div>
  </div>
</Modal>


<Modal
  title={<span className="text-lg font-bold">Update First Installment Date</span>}
  visible={installmentDateModalVisible}
  onCancel={() => {
    setInstallmentDateModalVisible(false);
    setInstallmentDateRecord(null);
    setInstallmentDateValue(null);
  }}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
     <div className="text-sm text-gray-700">
      Update First Installment Date to : <strong className="text-sm text-red-700">{installmentDateRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={installmentDateRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">First Installment Date</label>
      <DatePicker
        value={installmentDateValue}
        onChange={(d) => setInstallmentDateValue(d)}
        format="DD-MM-YYYY"
        disabledDate={(current) => {
          if (!current) return false;
          const today = dayjs().startOf('day');
          const min = dayjs().subtract(1, 'year').startOf('day'); // 1 year behind
          // disable if date is after today (future) or before min (older than 1 year)
          return current.isAfter(today, 'day') || current.isBefore(min, 'day');
        }}
        style={{ width: '40%' }}
      />
      <div className="mt-1 text-xs text-gray-500">
        Select a date within the past year up to today (format: DD-MM-YYYY)
      </div>
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setInstallmentDateModalVisible(false)} disabled={installmentDateLoading}>
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={async () => {
          if (!installmentDateRecord || !installmentDateRecord.Email) {
            toast.error('No record selected');
            return;
          }
          if (!installmentDateValue || !installmentDateValue.isValid()) {
            toast.error('Select a valid date');
            return;
          }

          setInstallmentDateLoading(true);
          const keyName = `installmentDate-${installmentDateRecord.key}`;
          setInstallmentDateSendingKeys(prev => {
            const next = new Set(prev); next.add(keyName); return next;
          });

          const formatted = installmentDateValue.format('DD-MM-YYYY'); // e.g. 16-10-2025
          const payload = {
            Email: installmentDateRecord.Email,
            FirstInstallmentDate: formatted,
          };

          try {
            const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/firstinstallment/update-first-installment-date`;
            const res = await axios.put(url, payload, {
              headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
              timeout: 15000,
            });

            if (res?.data?.success || res?.status === 200 || res?.status === 201) {
              toast.success(res?.data?.message || 'First installment date updated');

              // update UI
              setLeads(prev => prev.map(r => r.key === installmentDateRecord.key ? { ...r, FirstInstallmentDate: formatted } : r));

              setInstallmentDateModalVisible(false);
            } else {
              toast.error(res?.data?.message || 'Failed to update date');
            }
          } catch (err) {
            console.error('update-first-installment-date error', err);
            const msg = err?.response?.data?.message || err?.message || 'Network/server error';
            toast.error(msg);
          } finally {
            setInstallmentDateLoading(false);
            setInstallmentDateSendingKeys(prev => {
              const next = new Set(prev);
              next.delete(keyName);
              return next;
            });
          }
        }}
        disabled={installmentDateLoading}
        className="bg-blue-600"
      >
        {installmentDateLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" />Updating...</span> : 'Update First Installment Date'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Paid Amount</span>}
  visible={amountModalVisible}
  onCancel={() => {
    setAmountModalVisible(false);
    setAmountRecord(null);
    setAmountValue(null);
  }}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
     <div className="text-sm text-gray-700">
      Update Installment Paid Amount to : <strong className="text-sm text-red-700">{amountRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={amountRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Enrollment Type</label>
      <input
        type="text"
        value={amountRecord?.EnrollmentType ?? '-'}
        readOnly
        className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-md"
      />
    </div>

    <div>
  <label className="block mb-1 text-gray-600 text-md">
    Amount Paid
  </label>

  <Input
    type="number"
    value={amountValue}
    onChange={(e) =>
      setAmountValue(e.target.value)
    }
    placeholder={
      String(
        amountRecord?.EnrollmentType ?? ""
      )
        .toUpperCase()
        .includes("JUNIOR")
        ? "Enter Amount (Recommended: 12500)"
        : String(
            amountRecord?.EnrollmentType ?? ""
          )
            .toUpperCase()
            .includes("SENIOR")
        ? "Enter Amount (Recommended: 25000)"
        : "Enter Amount"
    }
    style={{ width: "50%" }}
    className="!h-11"
  />

  <div className="mt-1 text-xs font-semibold text-gray-500">
    {String(
      amountRecord?.EnrollmentType ?? ""
    )
      .toUpperCase()
      .includes("JUNIOR")
      ? "Recommended Amount: ₹12,500/-"
      : String(
          amountRecord?.EnrollmentType ?? ""
        )
          .toUpperCase()
          .includes("SENIOR")
      ? "Recommended Amount: ₹25,000/-"
      : "Allowed Amounts: ₹12,500/- or ₹25,000/-"}
  </div>
</div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setAmountModalVisible(false)} disabled={amountLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={() => handleAmountPaid(amountRecord)}
        disabled={amountLoading || !amountValue}
        className="bg-blue-600"
      >
        {amountLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Updating...</span> : 'Update Paid Amount'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Send Joining Message</span>}
  visible={joiningModalVisible}
  onCancel={() => {
    setJoiningModalVisible(false);
    setJoiningRecord(null);
  }}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
     <div className="text-sm text-gray-700">
      Joining Message Sending to : <strong className="text-sm text-red-700">{joiningRecord?.FullName ?? '-'}</strong>
    </div>
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={joiningRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Phone Number</label>
      <input
        type="text"
        value={joiningRecord?.PhoneNumber ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-md"
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => { setJoiningModalVisible(false); setJoiningRecord(null); }} disabled={joiningModalLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={() => handleSendJoiningMessage(joiningRecord)}
        disabled={joiningModalLoading}
        className="bg-blue-600"
      >
        {joiningModalLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Sending...</span> : 'Send Joining Message'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Comment</span>}
  open={commentModalVisible}
  onCancel={() => {
    setCommentModalVisible(false);
    setCommentRecord(null);
    setCommentValue("");
  }}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">
          {commentRecord?.FullName ?? "-"}
        </strong>
      </div>

      <div className="mb-2 text-sm text-gray-800">
        Email :{" "}
        <strong className="text-blue-800">
          {commentRecord?.Email ?? "-"}
        </strong>
      </div>

      <div className="text-sm text-gray-800">
        Phone Number :{" "}
        <strong className="text-green-800">
          {commentRecord?.PhoneNumber ?? "-"}
        </strong>
      </div>
    </div>

    <Input.TextArea
      rows={5}
      value={commentValue}
      onChange={(e) => setCommentValue(e.target.value)}
      placeholder="Enter first installment comment..."
      disabled={commentLoading}
      maxLength={1000}
      showCount
    />

    <div className="flex items-center justify-end gap-3">
      <Button
        onClick={() => {
          setCommentModalVisible(false);
          setCommentRecord(null);
          setCommentValue("");
        }}
        disabled={commentLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleUpdateComment}
        disabled={commentLoading || !commentValue.trim()}
        className="bg-blue-600"
      >
        {commentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Update Comment"
        )}
      </Button>
    </div>
  </div>
</Modal>


    </div>
  );
}

export default FirstInstallments;
